import dayjs from "dayjs";
import React, { useMemo } from "react";
import { Direction, IBookingTravelSummary, IOption, ITravelSegment } from "../../Models";
import { getStrings } from "../../../Shared/Reservation/StringResources";
import { Badge } from "react-bootstrap";
import { getSettings, getTravelMethodIcon } from "../../Settings";
import { ITableBooking } from "../../ManageBooking/Model";
import { getKrogenProductCodes } from "../../TravelDetails/KrogenOptionsHelpers";

const orderStrings = getStrings().component.orderSummary;
const commonStrings = getStrings().component.common;

const krogenProductCodes = getKrogenProductCodes();

export const TravelBaseInformation = (props: { travel: IBookingTravelSummary; direction: Direction;}) => {
	const departure = dayjs(props.travel.departure);
	const arrival = dayjs(props.travel.arrival);
	const traveltime = dayjs.duration(arrival.diff(departure));

	return <>
		{ props.travel.cancelled && <Badge variant="danger" className="mb-2">{commonStrings.cancelled}</Badge>}
		<dl className="mb-3">
			<dt>{orderStrings.departure}</dt>
			<dd>{dayjs(props.travel.departure).format("llll")} {commonStrings.from} {props.travel.from.name}</dd>
			<dt>{orderStrings.arrival}</dt>
			<dd>{dayjs(props.travel.arrival).format("llll")} {commonStrings.to} {props.travel.to.name}</dd>
			<dt>{orderStrings.duration}</dt>
			<dd>
				{Math.floor(traveltime.asHours())} {commonStrings.hours} {traveltime.minutes()} {commonStrings.minutes}
				{props.travel.segments?.length === 1 && `, ${orderStrings.direct.toLowerCase()}` }
				{props.travel.segments?.length === 2 && `,  1 ${orderStrings.change}` }
				{props.travel.segments?.length > 2 && `,  ${props.travel.segments.length-1} ${orderStrings.changes}` }
			</dd>
		</dl>
	</>;
}


export const SegmentInformation = (props: { segment: ITravelSegment, tableBookings?: ITableBooking[] }) => {

	const segment = props.segment;
	const tableBookings = props.tableBookings?.sort((a, b) => dayjs(`${a.date}T${a.time}`).isBefore(`${b.date}T${b.time}`) ? -1 : 1);

	const options = useMemo(() => getSettings()?.enableMealBooking ? segment.options.filter(x => !krogenProductCodes.includes(x.code)) : segment.options, [segment.options]);

	return <>
		<h4><i className={`travelmethod-icon travelmethod-icon-${getTravelMethodIcon(segment.serviceType.modality)}`}></i>{segment.from.name} ➔ {segment.to.name}</h4>
		<Badge variant="light" className="service-info">{segment.serviceType.name} {segment.serviceName}</Badge><br />
		{segment.seats?.length > 0 ? <ul className="list-unstyled">
			{segment.seats.map((seat, j) => <li key={j}>
				{orderStrings.carriage} {seat.carriage},&nbsp;
				{seat.compartment && <>{orderStrings.compartment} {seat.compartment},&nbsp;</>}
				{orderStrings.seat} {seat.number}
			</li>)}
		</ul> : orderStrings.noSeatReservation }

		{options?.length > 0 && <div>
			<h4>{orderStrings.options}</h4>
			<OptionList options={options} />
		</div>}

		{ tableBookings?.length > 0 && <div>
			<strong>{orderStrings.tableBookingsHeading}</strong><br />

			{tableBookings.map(tableBooking => <div key={tableBooking.bookingId}>
				{tableBooking.time}, {tableBooking.persons} {tableBooking.persons > 1 ? commonStrings.persons : commonStrings.person}
			</div>)}
		</div>}
	</>;
}

export const OptionList = (props: { options: IOption[] }) => {
	return <ul className="list-unstyled">
	{props.options.map(opt => <li key={opt.code}>
		{ opt.provisionalCount ?
			<><em>{opt.name} × {opt.count + opt.provisionalCount}</em> <Badge variant="warning" className="ml-2">{commonStrings.notPaid}</Badge></>:
			<>{opt.name} × {opt.count}</>}
	</li>)}
</ul>
}